import axios from "axios";
import { EventBus } from "@/EventBus.js";

// const API_URL = 'http://api.tchetasks';
const API_URL = 'https://fw.dev.br/tchetasks/api/';

export default {
    apiAjax(params) {
        // let sessionObj = JSON.parse(sessionStorage.getItem('vue-session-key')) || {};
        const sessionObj = JSON.parse(localStorage.getItem("vue-session-key")) || {};

        params.method = params.method ? params.method : "get";
        // let url = (params.baseUrl || API_URL) + params.url;

        const headersObj = {};
        if ( sessionObj.Authorization !== undefined && sessionObj.Authorization !== "") {
            headersObj.Authorization = sessionObj.Authorization;
        }
        if (sessionObj.Sessao !== undefined && sessionObj.Sessao !== "") {
            headersObj['Session-Id'] = sessionObj.Sessao;
        }

        axios({
            url: params.url,
            baseURL: params.baseUrl || API_URL,
            method: params.method,
            headers: headersObj,
            validateStatus: (status) => status < 500,
            // For GET e DELETE send params, that goes on url query, and for POST and PUT,send data in the request body
            params: params.method === "get" ? params.params : null,
            data: ["post", "put"].indexOf(params.method) !== -1 ? params.params : null
        }).then((response) => {
            if (response.status === 401) {
                if (
                    params.url !== "sessao" &&
                    params.method !== "post" &&
                    (params.url !== "/" && params.method !== "get")
                ) {
                    EventBus.$emit("sessionExpired");
                    return;
                }
            }
            if (response.data.success === false) {
                // let showErrorMessage = (params.failure) ? params.failure(response.data, response) : true;
                // if (showErrorMessage !== false) {
                //   EventBus.$emit('showErrorDialog', 'Erro no servidor');
                // }
                if (params.failure) {
                    params.failure(response.data, response);
                } else {
                    EventBus.$emit("showErrorDialog", "Erro no servidor");
                }
            } else if (params.success) {
                params.success(response.data, response);
            }
        })
        .catch((err, response) => {
            const showErrorMessage = params.failure ? params.failure(err, response) : true;
            if (showErrorMessage !== false) {
                EventBus.$emit(
                    "showErrorDialog",
                    "Erro ao comunicar com o servidor"
                );
            }
        });
    }
};